import { render, staticRenderFns } from "./driverManagement.vue?vue&type=template&id=6c07bac0"
import script from "./driverManagement.vue?vue&type=script&lang=js"
export * from "./driverManagement.vue?vue&type=script&lang=js"
import style0 from "./driverManagement.vue?vue&type=style&index=0&id=6c07bac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports